// Number of required requested-fields the viewer has not yet answered. Drives the count pill on the
// recipient "Requested Information" tab; reaches zero once every required field has a value.
export function countOutstandingRequiredFields(fields = [], values = {}) {
    return (fields ?? []).filter((field) => field?.required && !isAnswered(values?.[field.id])).length
}

// Number of requested-fields this response actually answered. Drives the count badge on each
// recipient row in the internal reviewer's collapsed "Requested Information" list.
export function countAnsweredFields(fields = [], values = {}) {
    return (fields ?? []).filter((field) => field?.id && isAnswered(values?.[field.id])).length
}

function isAnswered(value) {
    if (value === null || value === undefined) return false
    if (typeof value === "string") return value.trim() !== ""
    if (Array.isArray(value)) return value.length > 0
    return true
}
